var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"blackBox",staticClass:"blackBox"}),_c('transition',{attrs:{"mode":"out-in"},on:{"appear":_vm.rvEnter,"leave":_vm.rvLeave,"enter":_vm.rvEnter}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }